import * as a from 'actions/livefeed/historyActions'
import update from 'immutability-helper';

export default (state, action) => {
    switch (action.type) {
        // ------------------------------------History state update
        case a.SET_ENTITY: {
            return update(state, {
                livefeedSlides: { [action.entity.slideCurrentIndex]: { historyEntities: { $push: [action.entity] } } }
            })
        }
        case a.SET_ENTITY_FONT: {
            return update(state, {
                livefeedSlides: { [action.entity.slideCurrentIndex]: { historyEntities: { $push: [action.entity] } } }
            })
        }
        case a.EMPTY_ENTITY: {
            return update(state, {
                livefeedSlides: { [action.slideCurrentIndex]: { historyEntities: { $push: [action.entity] } } }
            })
        }
        case a.SET_STEP_NUMBER_STATE: {
            return {
                ...state,
                stepNumberState: action.step
            }
        }
        case a.CLEAR_HISTORY: {
            return update(state, {
                livefeedSlides: { [action.slideCurrentIndex]: { historyEntities: { $set: action.payload } } }
            })
        }
        case a.OVERWRITE_HISTORY: {
            return update(state, {
                livefeedSlides: { [action.slideCurrentIndex]: { historyEntities: { $set: action.payload } } }
            })
        }
        default: {
            return state
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/livefeededitor/historyReducer.js